module.exports = function getResource(label, vars = []) {
    let resources = {
        found: 'Nous trouvons votre',
        color: 'Couleur:',
        sorry: 'Désolé, nous n’avons pas trouvé de teinte correspondante pour vous.',
        reviewShades: 'Continuer de chercher les teintes disponibles pour',
        selectShade: 'Sélectionner cette teinte',
        done: 'Terminé',
        closest: 'correspondance la plus proche',
        exact: 'correspondance exacte',
        seeAllProducts: 'See all products in this shade',
        foundMultiShade: 'We found your shade'
    };

    return resources[label];
};
